var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThunder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46.359,
    height: 40.826,
    viewBox: "0 0 46.359 40.826",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.493,
    y1: 1.003,
    x2: 0.493,
    y2: 0.002,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#78d7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93eaf8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.497,
    y1: 1,
    x2: 0.497,
    y2: 0.001,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5b537d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76709a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.492,
    y1: 1.003,
    x2: 0.492,
    y2: 0.001,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    y1: 0.502,
    x2: 1.003,
    y2: 0.502,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efb535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe133"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0.023)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8216",
    "data-name": "Path 8216",
    d: "M40.91,29.07l-2-3.79h0a1,1,0,0,0-1.85,0h0l-2.11,3.9a3.48,3.48,0,0,0-.22.43h0a3.43,3.43,0,0,0-.31,1.43,3.58,3.58,0,1,0,6.54-2Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8217",
    "data-name": "Path 8217",
    d: "M40.41,16.4h-.23a7.52,7.52,0,0,0,.18-1.59,7.28,7.28,0,0,0-7.28-7.28h0a7.26,7.26,0,0,0-1.82.24A11.59,11.59,0,0,0,8.78,10.39H8.71A8.71,8.71,0,0,0,0,19.1H0a8.71,8.71,0,0,0,8.71,8.71h31.7a5.71,5.71,0,1,0,0-11.41Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8218",
    "data-name": "Path 8218",
    d: "M29.6,35.24l-2-3.79h0a1,1,0,0,0-1.84,0h0l-2.11,3.9c-.08.14-.16.28-.23.42h0a3.64,3.64,0,0,0-.3,1.44,3.58,3.58,0,1,0,6.54-2Z",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8219",
    "data-name": "Path 8219",
    d: "M24,18H14.67a1,1,0,0,0-1,.71L10.25,28.83a.59.59,0,0,0,.56.78H14.1L11,38.56a1,1,0,0,0,1.67.91l11-14.1a.61.61,0,0,0-.48-1H20.23l4.11-5.67A.47.47,0,0,0,24,18Z",
    fill: "url(#linear-gradient-4)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunder);
export default __webpack_public_path__ + "static/media/Thunder.8d602590caa6d16f53238df818a19c94.svg";
export { ForwardRef as ReactComponent };